// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.star-note{display:flex;align-items:center;height:1.5rem}`, "",{"version":3,"sources":["webpack://./src/Pages/Student/StarNote/StarNote.style.scss"],"names":[],"mappings":"AAAA,WACE,YAAA,CACA,kBAAA,CACA,aAAA","sourcesContent":[".star-note {\n  display: flex;\n  align-items: center;\n  height: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
